module.exports = __webpack_public_path__ + "static/media/plus.818e2f1d.svg";